// extracted by mini-css-extract-plugin
export default {"textFieldContainer":"AXCrk8","label":"MHZbAv","BoxSelectionOption":"Wl97wE","boxSelectionOption":"Wl97wE","BoxSelectionOptionMobile":"_i9ERj","boxSelectionOptionMobile":"_i9ERj"};